'use client';

import React from 'react';
import Header from './Header';
import BodyWidth from '@/components/layout/BodyWidth';
import Footer from '@/components/footer';
import { UserProps } from '@/context/auth';

type Props = {
  needViewPort?: boolean;
  isSalaryLink?: boolean;
  hideHeader?: boolean;
  isHomePage?: boolean;
} & UserProps;

const Layout = (props: Props) => {
  const {
    children,
    needViewPort = false,
    isSalaryLink,
    hideHeader = false,
    isHomePage,
  } = props;

  if (!children) return null;

  return (
    <>
      <BodyWidth needViewPort={needViewPort} />
      {!hideHeader && (
        <Header isSalaryLink={isSalaryLink} isHomePage={isHomePage} />
      )}
      <main className="min-h-screen w-full pt-16 pb-7">{children}</main>
      <Footer />
    </>
  );
};

export default Layout;
